import parsePhoneNumber, { isValidPhoneNumber } from 'libphonenumber-js';

export const validatePhoneNumberIfNotNull = (phoneNumber: string | null | undefined) =>
  !phoneNumber || validatePhoneNumber(phoneNumber);

export const validatePhoneNumber = (phoneNumber: string | null | undefined) =>
  !!phoneNumber && isValidPhoneNumber(phoneNumber);

const domTom = ['gp', 'mq', 'gf', 're', 'yt', 'pm', 'bl', 'mf', 'nc', 'pf', 'wf', 'tf'];

export const supportedPhoneCountries = ['fr', 'ch', 'mc', 'be', 'lu', 'ad'].concat(domTom);

export const formatPhoneNumberWithCountryCode = (phoneNumber: string) => {
  return parsePhoneNumber(phoneNumber)?.formatInternational() || phoneNumber;
};

export const normalizePhoneNumber = (phoneNumber: string) => phoneNumber.replace('+33', '0');

export const formatPhoneNumberWithSpaces = (phoneNumber: string) =>
  phoneNumber.replace(/(.{2})(?=.)/g, '$1 ');

export const isFrenchMobilePhoneNumber = (phoneNumber: string | null | undefined): boolean => {
  if (!phoneNumber) return false;

  try {
    const parsed = parsePhoneNumber(phoneNumber);
    if (!parsed) return false;

    // Only check French numbers
    if (parsed.country !== 'FR') return false;

    const nationalNumber = parsed.nationalNumber;
    // French mobile numbers start with 6 or 7
    return nationalNumber.startsWith('6') || nationalNumber.startsWith('7');
  } catch {
    return false;
  }
};
